// eslint-disable-next-line @tseslint/typedef
export const CUSTOMER_ROUTE_NAMES = {
  settings: "settings",
  details: "details",
  documents: "documents",
  personsOfContact: "persons-of-contact",
  employees: "employees",
  projects: "projects",
  systemStatus: "system-status"
} as const;
